import { Component, OnInit } from '@angular/core';
import { UserProfileInterface } from 'src/app/interface/user-profile.interface';
import { OpenIdService, OpenIdProfile } from 'src/app/service/open-id.service';

@Component({
    selector: 'app-component-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
    public openIdProfile?: OpenIdProfile;

    constructor(private openIdService: OpenIdService) {}

    ngOnInit(): void {
        this.openIdService.$userProfile.subscribe(
            (openIdProfile: OpenIdProfile) => {
                if (!openIdProfile) return;
                this.openIdProfile = openIdProfile;
            }
        );
    }
}
